var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPropertyname(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 6C14.75 5.58579 14.4142 5.25 14 5.25C13.5858 5.25 13.25 5.58579 13.25 6H14.75ZM13.25 6V8H14.75V6H13.25Z",
    fill: "#2D3546"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 6C10.75 5.58579 10.4142 5.25 10 5.25C9.58579 5.25 9.25 5.58579 9.25 6H10.75ZM9.25 6V8H10.75V6H9.25Z",
    fill: "#2D3546"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 18C8.75 17.5858 8.41421 17.25 8 17.25C7.58579 17.25 7.25 17.5858 7.25 18H8.75ZM7.25 18V22H8.75V18H7.25Z",
    fill: "#2D3546"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 18C16.75 17.5858 16.4142 17.25 16 17.25C15.5858 17.25 15.25 17.5858 15.25 18H16.75ZM15.25 18V22H16.75V18H15.25Z",
    fill: "#2D3546"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18 22H6",
    stroke: "#2D3546",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8069 3H8.91131C8.14435 3 7.76087 3 7.4854 3.14445C7.36614 3.20699 7.26375 3.28735 7.18407 3.38094C7 3.59713 7 3.89809 7 4.5C7 5.10191 7 5.40287 7.18407 5.61906C7.26375 5.71265 7.36614 5.79301 7.4854 5.85555C7.76087 6 8.14435 6 8.91131 6H14.8069C15.166 6 15.3455 6 15.5103 5.95791C15.583 5.93935 15.653 5.91484 15.7192 5.8848C15.8691 5.81671 15.9891 5.71187 16.229 5.50219C16.6936 5.09617 16.9259 4.89316 16.9818 4.65592C17.0061 4.55285 17.0061 4.44715 16.9818 4.34408C16.9259 4.10684 16.6936 3.90383 16.229 3.49781C15.9891 3.28813 15.8691 3.18329 15.7192 3.1152C15.653 3.08516 15.583 3.06065 15.5103 3.04209C15.3455 3 15.166 3 14.8069 3Z",
    stroke: "#2D3546",
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6 11H18",
    stroke: "#2D3546",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14H16",
    stroke: "#2D3546",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 8,
    width: 18,
    height: 10,
    rx: 2,
    stroke: "#2D3546",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropertyname);
export default __webpack_public_path__ + "static/media/Property name.004bd009c77e41235fbc6c42264f8775.svg";
export { ForwardRef as ReactComponent };